import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { sparklineSchema } from './sparkline.schema';

const _GetAverageNumberOfResidentsRequestDtoSchema = z.object({
  /**
   * Omit to average across every facility the user can see (Portfolio Mode); pass an id to
   * scope to one facility.
   */
  facilityId: z.string().optional(),
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetAverageNumberOfResidentsResponseDtoSchema = z.object({
  avgResidents: z.number().nullable(),
  avgResidentsChangePct: z.number().nullable(),
  sparkline: sparklineSchema,
});

export type GetAverageNumberOfResidentsRequestDto = z.infer<
  typeof _GetAverageNumberOfResidentsRequestDtoSchema
>;

export type GetAverageNumberOfResidentsResponseDto = z.infer<
  typeof GetAverageNumberOfResidentsResponseDtoSchema
>;

export const getAverageNumberOfResidents = (
  params: GetAverageNumberOfResidentsRequestDto,
  config?: AxiosRequestConfig<GetAverageNumberOfResidentsRequestDto>
) => {
  const { facilityId, ...query } = params;

  const url = facilityId
    ? `facilities/${facilityId}/average-number-of-residents`
    : 'facilities/average-number-of-residents';

  return api
    .get(url, { params: query, ...config })
    .then(responseContract(GetAverageNumberOfResidentsResponseDtoSchema));
};
